module.exports = __webpack_public_path__ + "static/Products-c354f43cc3bf1d23d3e09641905374ba.png";